/*
 * Copyright (c) 2021
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ListItem, styled } from "@mui/material"
import { SxProps } from "@mui/system"
import { Theme } from "@mui/material/styles"
import { Link } from "react-router-dom"
import { PropsWithChildren, useEffect, useRef } from "react"

interface LinkListItemProps {
    to: string
    selected?: boolean
    sx?: SxProps<Theme>
}

export default function LinkListItem(props: PropsWithChildren<LinkListItemProps>) {
    const ref = useRef<any>(null)
    useEffect(() => {
        if (props.selected) ref.current?.scrollIntoView({ behavior: "smooth", block: "nearest" })
    })
    return (
        <ListItem ref={ref} component={UnstyledLink} {...props}>
            {props.children}
        </ListItem>
    )
}

const UnstyledLink = styled(Link, {})`
    color: inherit;
`
